/**
 * Preview Environment Detection
 *
 * Returns true ONLY when the app is running in a non-production environment
 * (Emergent preview/fork pods or local dev). This is used to gate internal
 * test-only affordances (e.g. enabling Memory Vault creation while the
 * public live site still shows "Arriving Soon").
 *
 * Detection rules (all evaluated in the browser):
 *   • hostname contains "preview.emergentagent.com"  → preview pod
 *   • hostname is localhost / 127.0.0.1              → local dev
 *
 * Anything else (custom domains, www.sent2ment.com, etc.) is treated as
 * production and returns false.
 */

/* ─────────────────────────────────────────────────────────────────────────
 * TEMPORARY OVERRIDE — 2026-04-27
 * Set to `true` while the user is testing the full purchase + Memory Vault
 * flow against production. This removes the "Arriving Soon" gate everywhere
 * `isPreviewEnv()` is consulted (Memory Vault landing CTAs + LTL add-on toggle).
 *
 * To re-enable the "Arriving Soon" production gate later, change this
 * constant back to `false`. No other code needs to change.
 * ───────────────────────────────────────────────────────────────────────── */
const TEMP_FORCE_UNLOCK = false;

export const isPreviewEnv = () => {
  if (TEMP_FORCE_UNLOCK) return true;
  if (typeof window === 'undefined' || !window.location) return false;
  const host = window.location.hostname || '';
  if (host.includes('preview.emergentagent.com')) return true;
  if (host === 'localhost' || host === '127.0.0.1') return true;
  return false;
};
